import { queryExists } from '@/api/common'
import { WhitelistTypeEnums } from '@/enums'
import NewMETypeEnum from '@/i18n/GeaExplorerTypeLangs/en_US'
import { getValueByPathOne } from '@/utils/number'
const item = NewMETypeEnum.translation.find((item) => {
  return item.globalLabel === 'ModuleAddressType'
})
interface I_NewMETypeEnumItem {
  globalLabel: string
  keyList: any[]
  newGlobalLabel: string
  jumpType?: string
  [key: string]: any
}

const getLabel = ({
  currentLang = 'zh_TW',
  keyLangs = [],
}: {
  currentLang: string
  keyLangs: any[]
}) => {
  const item = keyLangs.find((item: { [key: string]: any }) =>
    Object.prototype.hasOwnProperty.call(item, currentLang),
  )
  return `${item[currentLang]}`
}

// 获取交易类型
const NewMETypeEnumJavaLangs = NewMETypeEnum.translation as I_NewMETypeEnumItem[]

// 根据路径获取值

interface I_getValueByPath {
  (
    obj: { [key: string]: any },
    path: string,
  ): {
    value: any
    parse: boolean
    key: string
  }
}

const getValueByPath: I_getValueByPath = (obj, path) => {
  if (!obj || typeof obj !== 'object' || !path || typeof path !== 'string') {
    return {
      value: '-',
      parse: false,
      key: path,
    }
  }
  // 将路径字符串转换为路径数组
  // 处理 transaction[0]/msgs[0]/value/creator 这样的路径
  const pathSegments = path.split('/').filter((segment) => segment !== '')
  let current = obj
  for (const segment of pathSegments) {
    // 检查是否是数组项，如 msgs[0]
    // const arrayMatch = segment.match(/^([^\[]+)\[(\d+)\]$/)
    const arrayMatch = segment.match(/^([^[\]]+)\[(\d+)\]$/)
    if (arrayMatch) {
      const key = arrayMatch[1]
      const index = parseInt(arrayMatch[2], 10)
      if (current[key] && Array.isArray(current[key]) && current[key][index] !== undefined) {
        current = current[key][index]
      } else {
        return {
          value: '-',
          parse: false,
          key: path,
        }
      }
    } else {
      // 普通对象属性
      if (current[segment] !== undefined && current[segment] !== null) {
        current = current[segment]
      } else {
        return {
          value: '-',
          parse: false,
          key: path,
        }
      }
    }
  }

  return current !== undefined
    ? {
        value: current,
        parse: true,
        key: path,
      }
    : {
        value: '-',
        parse: false,
        key: path,
      }
}

/**
 * 获取交易类型
 * @param type
 * @returns
 */
export const getTransactionType = (type: string, transactionDetail: any = {}) => {
  if (!type || PhaseIItransactionTypeArray.includes(type))
    return {
      pageTitle: '-',
      pageKeyList: [],
      pageKeyListOther: [],
    }
  // getLanguage()、
  const language = window.location.pathname.slice(1, 6).replace('-', '_') || 'en-US'
  // const language = localStorage.getItem('language') || 'en-US'
  const findLangsYkey = NewMETypeEnumJavaLangs.find(
    (item: I_NewMETypeEnumItem) => item?.newGlobalLabel?.trim() === type,
  )
  // console.log('findLangsYkey', findLangsYkey)
  if (!findLangsYkey) {
    console.error('findLangsYkey异常', type)
    return {
      pageTitle: '-',
      pageKeyList: [],
      pageKeyListOther: [],
    }
  }
  const pageDataInfo: { pageTitle: string; pageKeyList: any[]; pageKeyListOther: any[] } = {
    pageTitle: '',
    pageKeyList: [],
    pageKeyListOther: [],
  }

  const { keyList = [] } = JSON.parse(JSON.stringify(findLangsYkey))
  const pageTitle = keyList[0].keyLangs.find((item: any) =>
    Object.prototype.hasOwnProperty.call(item, language),
  )
  pageDataInfo.pageTitle = pageTitle[language]

  let newKeyList = []
  if (!['ModuleAddressType', 'ModuleAddressName', 'ModuleAddressDesc'].includes(type)) {
    newKeyList = keyList.slice(1)
  } else {
    newKeyList = keyList
  }
  const transNewKeyList = newKeyList.map((item: any) => {
    const language = window.location.pathname.slice(1, 6).replace('-', '_')
    // currentLang: localStorage.getItem('language') || 'zh_TW',
    const { keyLabel, keyLangs } = item
    const obj: any = {
      label: getLabel({
        currentLang: language || 'en-US',
        keyLangs,
      }),
      value: (transactionData: { [key: string]: any }, t: any, cusKey: string) => {
        if (transactionData) {
          const { key } = getValueByPathOne(transactionData, item.keyLabel)
          // 处理需要调用接口的部分
          if (key?.includes('rest/account/asset-change-log')) {
            const numTyleGEA = item.keyLangs.find((item: any) => {
              return Object.values(item).some((i: any) => i.includes('GEA'))
            })
            const numTyleGAG = item.keyLangs.find((item: any) =>
              Object.values(item).some((i: any) => i.includes('GAG')),
            )
            if (numTyleGEA) {
              return 'account/asset-change-log-GEA'
            }
            if (numTyleGAG) {
              return 'account/asset-change-log-GAG'
            }
            return 'account/asset-change-log'
          }
          // 白名单类型
          if (item.keyLabel === 'transaction/msgs[0]/body/whitelist_type') {
            const value = getValueByPathOne(transactionData, item.keyLabel).value
            return WhitelistTypeEnums[value as keyof typeof WhitelistTypeEnums]
              ? t(WhitelistTypeEnums[value as keyof typeof WhitelistTypeEnums])
              : '-'
          }
          // ibc.core.client.v1.MsgCreateClient 有可能是在hub，有可能是在rollup，当在rollup时，tx[0]是存在的，替换transaction
          if (type === 'ibc.core.client.v1.MsgCreateClient' && transactionData.tx[0]) {
            item.keyLabel = item.keyLabel.replace('transaction', 'tx[0]')
          }
          return getValueByPathOne(transactionData, cusKey ? cusKey : item.keyLabel).value
        }
        return '-'
      },
      key: keyLabel,
    }
    if (Object.prototype.hasOwnProperty.call(item, 'jumpType')) {
      obj.jumpType = item.jumpType
    }
    return obj
  })
  // console.log('transNewKeyList', transNewKeyList)
  // gea.kyc.MsgUpdate 更新KYC
  // AGE (CHN Node) 质押（存入） gea.staking.MsgCreateLockUpDelegate
  // AGE (CHN Node) 质押赎回 gea.staking.MsgReduceLockUpDelegation
  // AGD (CHN Node) 节点质押取回 gea.staking.MsgUnDelegate
  // AGD (CHN Node) 质押(存入) gea.staking.MsgCreateDelegate
  // AGS (CHN Node) 质押（30）天 gea.staking.MsgCreateFixedDelegation
  // AGS (CHN Node) 质押赎回（30）天 gea.staking.MsgWithdrawFixedDelegation
  // 提取区块奖励 gea.staking.MsgWithdrawDelegationInterest
  if (
    [
      'gea.kyc.MsgUpdate',
      'gea.staking.MsgReduceLockUpDelegation',
      'gea.staking.MsgCreateLockUpDelegate',
      'gea.staking.MsgUnDelegate',
      'gea.staking.MsgCreateDelegate',
      'gea.staking.MsgCreateFixedDelegation',
    ].includes(type)
  ) {
    if (type === 'gea.kyc.MsgUpdate') {
      const delegate_interest_infoArr = []
      const value = transNewKeyList.splice(3, 5)
      // 找到所有的delegate_interest_info
      for (let i = 0; i < Infinity; i++) {
        const key = i
        const detail = transactionDetail?.transaction?.msgs?.[0]?.detail || {}
        const keyNew = `delegate_interest_info${key}`
        const delegate_interest_infoData = detail[keyNew]
        if (delegate_interest_infoData) {
          delegate_interest_infoArr.push(delegate_interest_infoData)
        } else {
          break
        }
      }
      if (delegate_interest_infoArr.length) {
        const valueArr = delegate_interest_infoArr.map((item: any, index) => {
          const data = value.map((item: any) => {
            return {
              ...item,
              key: item.key.replace('delegate_interest_info', `delegate_interest_info${index}`),
            }
          })
          return data
        })
        valueArr.reverse().forEach((item: any, index) => {
          transNewKeyList.splice(3, 0, {
            label: 'currentReward', //活期奖励,
            tip: 'explorer_248',
            value: item,
          })
        })
      } else {
        transNewKeyList.splice(3, 0, {
          label: 'currentReward', //活期奖励,
          tip: 'explorer_248',
          value,
        })
      }
    } else {
      const value = transNewKeyList.splice(3, 5)
      transNewKeyList.splice(3, 0, {
        label: 'currentReward', //活期奖励,
        tip: 'explorer_248',
        value,
      })
    }
    // 提取表格数据
  } else if (['gea.staking.MsgWithdrawDelegationInterest'].includes(type)) {
    const value = transNewKeyList.splice(2, 5)
    transNewKeyList.splice(2, 0, {
      label: 'currentReward', //活期奖励,
      tip: 'explorer_248',
      value,
    })
  } else if (['gea.staking.MsgWithdrawFixedDelegation'].includes(type)) {
    const pageKeyListOther = transNewKeyList.splice(3)
    const value = pageKeyListOther.splice(2, 5)
    pageKeyListOther.splice(2, 0, {
      label: 'currentReward', //活期奖励,
      tip: 'explorer_248',
      value,
    })
    pageDataInfo.pageKeyListOther = pageKeyListOther
  } else if (['gea.staking.MsgTransferRegion'].includes(type)) {
    const delegate_interest_info0 =
      transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info0
    const delegate_interest_info1 =
      transactionDetail?.transaction?.msgs?.[0]?.detail?.delegate_interest_info1
    if (delegate_interest_info0 && delegate_interest_info1) {
      const value1 = transNewKeyList.splice(3, 1)
      const value2 = transNewKeyList.splice(3, 5)
      transNewKeyList.splice(3, 0, {
        label: 'currentReward', //活期奖励,
        tip: 'explorer_248',
        value: value1,
        labelTwo: 'explorer_288',
        noShowGag: true,
      })
      const value3 = value2.map((item: any) => {
        return {
          ...item,
          key: item.key.replace('delegate_interest_info', 'delegate_interest_info0'),
        }
      })
      const value4 = value2.map((item: any) => {
        return {
          ...item,
          key: item.key.replace('delegate_interest_info', 'delegate_interest_info1'),
        }
      })
      transNewKeyList.splice(4, 0, {
        label: 'currentReward', //活期奖励,
        tip: 'explorer_248',
        value: value4,
        showLabelNone: true,
      })
      transNewKeyList.splice(4, 0, {
        label: 'currentReward', //活期奖励,
        tip: 'explorer_248',
        value: value3,
      })
    } else {
      const value1 = transNewKeyList.splice(3, 1)
      const value2 = transNewKeyList.splice(3, 5)
      transNewKeyList.splice(3, 0, {
        label: 'currentReward', //活期奖励,
        tip: 'explorer_248',
        value: value1,
        labelTwo: 'explorer_288',
        noShowGag: true,
      })
      transNewKeyList.splice(4, 0, {
        label: 'currentReward', //活期奖励,
        tip: 'explorer_248',
        value: value2,
      })
    }
  } else if (['gea.staking.MsgUpdateDelegatorAddress'].includes(type)) {
    const value = transNewKeyList.splice(2, 3)
    transNewKeyList.splice(2, 0, {
      label: 'currentReward', //,
      tip: 'explorer_248',
      labelTwo: 'explorer_288',
      value,
      noShowGag: true,
    })
  } else if (['gea.staking.MsgKycUsersTransferToNewRegion'].includes(type)) {
    const value1 = transNewKeyList.splice(2, 2)
    const value2 = transNewKeyList.splice(2, 5)
    transNewKeyList.splice(2, 0, {
      label: 'currentReward', //活期奖励,
      tip: 'explorer_248',
      value: value1,
      labelTwo: 'explorer_288',
      noShowGag: true,
    })
    transNewKeyList.splice(3, 0, {
      label: 'currentReward', //活期奖励,
      tip: 'explorer_248',
      value: value2,
    })
  }

  pageDataInfo.pageKeyList = transNewKeyList
  return pageDataInfo
}

export const getTermsDay = (key: string) => {
  const obj = {
    TERM_1_MONTHS: 1,
    TERM_2_MONTHS: 2,
    TERM_3_MONTHS: 3,
    TERM_4_MONTHS: 4,
    TERM_5_MONTHS: 5,
    TERM_6_MONTHS: 6,
    TERM_7_MONTHS: 7,
    TERM_8_MONTHS: 8,
    TERM_9_MONTHS: 9,
    TERM_10_MONTHS: 10,
    TERM_11_MONTHS: 11,
    TERM_12_MONTHS: 12,
    TERM_24_MONTHS: 24,
    TERM_36_MONTHS: 36,
    TERM_60_MONTHS: 60,
  }
  if (obj[key as keyof typeof obj]) {
    return Number(obj[key as keyof typeof obj]) * 30
  }
  return '-'
}

// 一期交易类型 展示交易类型
export const transactionTypeArray = [
  'cosmos.bank.v1beta1.MsgSend', // 转账
  'gea.checkin.MsgCheckIn', // 签到
  'gea.kyc.MsgApprove', //认证KYC
  'gea.kyc.MsgUpdate',
  'gea.staking.MsgSwap', //置换
  'gea.kyc.MsgAddWhiteList', // 添加白名单
  'gea.kyc.MsgRemoveWhiteList', // 移除白名单
  'gea.staking.MsgCreateLockUpDelegate', // AGE (CHN Node) 质押（存入）
  'gea.staking.MsgReduceLockUpDelegation', // AGE (CHN Node) 质押赎回
  'gea.staking.MsgWithdrawLockUpReward', //  AGE ({{ regionId }} Node)提取锁仓奖励
  'gea.staking.MsgCreateDelegate', //AGD (CHN Node) 质押(存入)
  'gea.staking.MsgUnDelegate', //AGD (CHN Node) 质押取回
  'gea.staking.MsgCreateFixedDelegation', //AGS (CHN Node) 质押（30）天,
  'gea.staking.MsgWithdrawFixedDelegation', //AGS (CHN Node) 质押赎回（30）天
  'gea.staking.MsgWithdrawDelegationInterest', //提取活期奖励
  'gea.staking.MsgUpdateDelegatorAddress', //質押轉移

  // 资管
  'gea.staking.MsgWithdrawFromSwapPool',
  'gea.staking.MsgDepositToInvitationRewardPool',
  'gea.staking.MsgWithdrawMintReward',
  'gea.staking.MsgTreasuryToSwapPool',
  'gea.staking.MsgDepositToSwapPool',
  'gea.staking.MsgWithdrawTreasury',
  'gea.staking.MsgWithdrawFromInvitationRewardPool',
  'gea.bank.MsgModuleAccountSend', //【ModuleAccountSend模块账号】转账给【ugag指定地址】 转账（多个模块账户的转账）

  // 二期
  'gea.kyc.MsgStar', // 星级变更
  'gea.committee.MsgVoteProposal', // 治理委员会提案投票
  'gea.rollapp.MsgUpdateState', // UpdateState
  'cosmos.staking.v1beta1.MsgCreateValidator', //創建驗證節點
  'cosmos.staking.v1beta1.MsgEditValidator', //更新验证节点
  'gea.rollapp.MsgCreateRollapp', // 创建Rollapp
  'gea.sequencer.MsgCreateSequencer', //创建Sequencer
  'gea.staking.MsgSetSwapRate', //设置 GEA 和 GAG 置换比例
  'gea.staking.MsgTransferRegion', // 转区申请
  'gea.committee.MsgStartElectoral', // 治理委員會競選發起
  'gea.committee.MsgRegisterCandidate', // 治理委員會競選報名
  'gea.committee.MsgVote', //投票地址
  'gea.committee.MsgEndElectoral', //治理委員會競選結束
  'gea.committee.MsgCreateProposal', //治理委员会提案提交
  'gea.committee.MsgUpdateCommittee', //委员会地址变更
  'gea.staking.MsgCreateRegion', //创建国家/区
  'gea.kyc.MsgRemove', //删除 Seed ID
  'gea.staking.MsgUpdateRegion', //更新国家/区
  'gea.staking.MsgSetFixedDelegationInterestRate', //更新 AGS 收益率
  'gea.staking.MsgKycUsersTransferToNewRegion', //用戶轉區
  'cosmos.gov.v1beta1.MsgSubmitProposal', //提案發起
  'cosmos.gov.v1beta1.MsgVote', //提案投票
  'gea.committee.MsgEndProposal',
]

// 二期交易类型 展示内容
export const PhaseIItransactionTypeArray: string[] = [
  // 'gea.kyc.MsgStar', // 星级变更
  // 'gea.committee.MsgVoteProposal', // 治理委员会提案投票
  // 'gea.rollapp.MsgUpdateState', // UpdateState
  // 'cosmos.staking.v1beta1.MsgCreateValidator', //創建驗證節點
  // 'cosmos.staking.v1beta1.MsgEditValidator', //更新验证节点
  // 'gea.rollapp.MsgCreateRollapp', // 创建Rollapp
  // 'gea.sequencer.MsgCreateSequencer', //创建Sequencer
  // 'gea.staking.MsgSetSwapRate', //设置 GEA 和 GAG 置换比例
  // 'gea.staking.MsgTransferRegion', // 转区申请
  // 'gea.committee.MsgStartElectoral', // 治理委員會競選發起
  // 'gea.committee.MsgRegisterCandidate', // 治理委員會競選報名
  // 'gea.committee.MsgVote', //投票地址
  // 'gea.committee.MsgEndElectoral', //治理委員會競選結束
  // 'gea.committee.MsgCreateProposal', //治理委员会提案提交
  // 'gea.committee.MsgUpdateCommittee', //委员会地址变更
  // 'gea.staking.MsgCreateRegion', //创建国家/区
  // 'gea.kyc.MsgRemove', //删除 Seed ID
  // 'gea.staking.MsgUpdateRegion', //更新国家/区
  // 'gea.staking.MsgSetFixedDelegationInterestRate', //更新 AGS 收益率
  // 'gea.staking.MsgKycUsersTransferToNewRegion', //用戶轉區
  // 'cosmos.gov.v1beta1.MsgSubmitProposal', //提案發起
  // 'cosmos.gov.v1beta1.MsgVote', //提案投票
  // 'gea.committee.MsgEndProposal',
]

export const handleAddressJump = async (searchValue: string, navigate: any) => {
  const res = await queryExists(searchValue)
  const result = res.existence_check[0]
  if (!result.search_type) {
    return
  }
  switch (result.search_type) {
    case 'account': // 普通地址
      navigate(`/accountDetail/${searchValue}`)
      break
    case 'module_account': // 模块地址
      navigate(`/moduleAccount/${searchValue}`)
      break
  }
}

// 转账特殊类型
export const SendMsgTagArray = [
  'task submit',
  'task review',
  'task challenge',
  'task submit reward',
  'task review reward',
  'task challenge reward',
  'star keep reward',
  'invite deposit reward',
]

export const CommitteeElectoralStatus = {
  VOTING: 'explorer_293',
  COMPLETED: 'explorer_292',
}

export const getSendMsgTag = (tag: any, t: any) => {
  if (tag === 'task submit') return t('tag_task_submit')
  if (tag === 'task review') return t('tag_task_review')
  if (tag === 'task challenge') return t('tag_task_challenge')
  if (tag === 'task submit reward') return t('tag_task_submit_rewar')
  if (tag === 'task review reward') return t('tag_task_review_reward')
  if (tag === 'task challenge reward') return t('tag_task_challenge_reward')
  if (tag === 'star keep reward') return t('tag_star_keep_reward')
  if (tag === 'invite deposit reward') return t('tag_invite_deposit_reward')
}
